import { render, staticRenderFns } from "./VModalFooter.vue?vue&type=template&id=30fb1ec6&scoped=true&"
import script from "./VModalFooter.vue?vue&type=script&lang=js&"
export * from "./VModalFooter.vue?vue&type=script&lang=js&"
import style0 from "./VModalFooter.vue?vue&type=style&index=0&id=30fb1ec6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fb1ec6",
  null
  
)

export default component.exports